import { Action } from '../types';
import type { LocationSummary } from '../../../networkRequest/locationsService';

// Types

export type FilterData = {
  locations: LocationSummary[];
  actions: Action[];
};

export type FilterState = {
  checkpointIds: Record<number, boolean>;
  actions: Record<string, boolean>;
};

export const buildInitialFilterState = (): FilterState => ({
  checkpointIds: {},
  actions: {}
});

// Convert FilterState to API query parameters
export const getFilterParams = (filterState: FilterState) => ({
  checkpointIds: Object.keys(filterState.checkpointIds),
  actions: Object.keys(filterState.actions)
});

// Derive display labels for active filters (used by FilterBar chips)
export const getFilterLabels = (
  filterState: FilterState,
  locations: LocationSummary[],
  actions: Action[]
): { key: string; label: string; value: string }[] => {
  const labels: { key: string; label: string; value: string }[] = [];

  const locationNames: string[] = [];
  locations.forEach(group => {
    const checkedCheckpoints = group.checkpoints.filter(c => filterState.checkpointIds[c.id]);
    if (checkedCheckpoints.length === group.checkpoints.length && checkedCheckpoints.length > 0) {
      locationNames.push(group.name);
    } else {
      checkedCheckpoints.forEach(c => locationNames.push(`${group.name}/${c.name}`));
    }
  });
  if (locationNames.length > 0) {
    labels.push({ key: 'location', label: 'Location/Checkpoint:', value: locationNames.join('; ') });
  }

  const actionLabels = actions
    .filter(a => filterState.actions[a.value])
    .map(a => a.name);
  if (actionLabels.length > 0) {
    labels.push({ key: 'action', label: 'Action:', value: actionLabels.join('; ') });
  }

  return labels.sort((a, b) => a.label.localeCompare(b.label));
};

export const clearLocations = (prev: FilterState): FilterState => ({
  ...prev,
  checkpointIds: {}
});

export const clearActions = (prev: FilterState): FilterState => ({
  ...prev,
  actions: {}
});
